<template>
  <vl-properties-list>
    <vl-properties-label>{{ $t('operationentity.detail.id') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.id }}</vl-properties-data>
    <vl-properties-label>{{ $t('operationentity.detail.code') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.code }}</vl-properties-data>
    <vl-properties-label>{{ $t('operationentity.detail.label') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.label }}</vl-properties-data>
    <vl-properties-label>{{ $t('operationentity.detail.description') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.description }}</vl-properties-data>
    <vl-properties-label>{{ $t('operationentity.detail.model') }}</vl-properties-label>
    <vl-properties-data> <PbsEntityRouterLink type="entityModel" :detail="props.detail.model" /> </vl-properties-data>
    <vl-properties-label v-if="!isCodeListOrTable">{{ $t('operationentity.detail.crs') }}</vl-properties-label>
    <vl-properties-data v-if="!isCodeListOrTable">{{ props.detail.crs.name }}</vl-properties-data>
  </vl-properties-list>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { OperationEntityDetailDto } from '@/api/backoffice/clients';
import PbsEntityRouterLink from '@/components/PbsEntityRouterLink.vue';
import { ENUM_EntityTypes } from '@/modules/configuration/common';

const isCodeListOrTable = computed((): boolean => {
  return props.detail?.model?.entityTypeName == ENUM_EntityTypes.CodeList.name || props.detail?.model?.entityTypeName == ENUM_EntityTypes.Table.name;
});

const props = defineProps<{
  detail: OperationEntityDetailDto;
}>();
</script>
